import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ciudadanos } from "../../config/apiConfig";
import Navbar from "../../components/Navbar";
import "./css/Estadisticas.css";
import StatisticsDashboard from "./Statistics";
import { useAuth } from "../../context/AuthContext";

const Estadisticas = () => {
  const [usuariosRechazados, setUsuariosRechazados] = useState([]);
  const { token } = useAuth();

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const res = await fetch(API_ciudadanos, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await res.json();
        if (Array.isArray(data)) {
          const rechazados = data.filter(
            (u) => u.estadoUsuario === "Rechazado"
          );
          setUsuariosRechazados(rechazados);
        }
      } catch (error) {
        console.error("Error al cargar usuarios:", error);
        setUsuariosRechazados([]);
      }
    };
    fetchUsuarios();
  }, [token]);

  return (
    <>
      <Navbar />

      <main className="main estadisticas">
        <StatisticsDashboard />
      </main>
    </>
  );
};

export default Estadisticas;
